import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { ResponseModel } from '../api-response.model'
import { BaseService } from '../base.service'

@Injectable({
  providedIn: 'root'
})
export class FileService extends BaseService {
  contextPath = this.path + '/files'

  upload(uploadFile: any): Observable<any> {
    const formData = new FormData()
    formData.append('files', uploadFile)
    formData.append('publicFlag', JSON.stringify(true))

    return this.post(`${this.contextPath}`, formData)
  }

  download(id: any): Observable<any> {
    return this.get(`${this.contextPath}/${id}/public`, null, undefined, { responseType: 'blob' as 'json' })
  }
}
